export default __webpack_public_path__ + "static/media/021-diving.123b542e.svg";